import React from "react";
import familyHome from "../iamges/family-home.png";

const reasons = [
  {
    icon: (
      <svg
        width='55'
        height='55'
        viewBox='0 0 55 55'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <rect
          width='55'
          height='55'
          rx='27.5'
          fill='#FF9D00'
          fill-opacity='0.16'
        />
        <circle cx='27.3374' cy='27.5' r='21.1538' fill='#FF9D00' />
        <path
          d='M27.5009 36.165L35.3292 32.1137C35.6334 31.9558 35.7855 31.8778 35.8962 31.7613C35.9943 31.659 36.0686 31.5364 36.1138 31.4022C36.1658 31.2491 36.1658 31.0787 36.1658 30.7359V23.1994M27.5009 36.165L19.6726 32.1137C19.3683 31.9558 19.2162 31.8778 19.1055 31.7613C19.0074 31.659 18.9332 31.5364 18.8879 31.4022C18.8359 31.2491 18.8359 31.0777 18.8359 30.734V23.1994M27.5009 36.165V27.4394M36.1658 23.1994L27.5009 27.4394M36.1658 23.1994L31.8333 20.9561M18.8359 23.1994L26.7971 19.0797C27.0551 18.9468 27.1832 18.8794 27.3189 18.8534C27.4391 18.8303 27.5626 18.8303 27.6828 18.8534C27.8176 18.8794 27.9466 18.9468 28.2037 19.0797L31.8333 20.9561M18.8359 23.1994L23.1684 25.3203M27.5009 27.4394L23.1684 25.3194M31.8333 20.9561L23.1684 25.3194M23.1684 25.3194V27.4394'
          stroke='white'
          stroke-width='1.44416'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </svg>
    ),
    title: "Save hours of what you need",
    body: "With our customized checklists for tenant move-in, move-out, buying rental property, and selling property—you won’t miss anything important.",
  },
  {
    icon: (
      <svg
        width='55'
        height='55'
        viewBox='0 0 55 55'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <rect
          width='55'
          height='55'
          rx='27.5'
          fill='#FF9D00'
          fill-opacity='0.16'
        />
        <circle cx='27.3374' cy='27.5' r='21.1538' fill='#FF9D00' />
        <path
          d='M35.4453 19.6968H20.4453C20.0475 19.6968 19.666 19.8548 19.3847 20.1361C19.1033 20.4174 18.9453 20.799 18.9453 21.1968V26.4468C18.9453 31.3893 21.3378 34.3846 23.345 36.0271C25.5069 37.7952 27.6575 38.3962 27.7513 38.4205C27.8802 38.4556 28.0161 38.4556 28.145 38.4205C28.2388 38.3962 30.3866 37.7952 32.5513 36.0271C34.5528 34.3846 36.9453 31.3893 36.9453 26.4468V21.1968C36.9453 20.799 36.7873 20.4174 36.506 20.1361C36.2247 19.8548 35.8431 19.6968 35.4453 19.6968ZM35.4453 26.4468C35.4453 29.9221 34.1647 32.743 31.6391 34.8299C30.5396 35.7353 29.2893 36.4398 27.9453 36.9112C26.6189 36.448 25.384 35.756 24.2966 34.8665C21.7409 32.7758 20.4453 29.9437 20.4453 26.4468V21.1968H35.4453V26.4468Z'
          fill='white'
        />
      </svg>
    ),
    title: "Avoid Costly Mistakes",
    body: "Never miss maintenance again. Prevent expensive repairs with timely reminders and proper documentation.",
  },
  {
    icon: (
      <svg
        width='55'
        height='55'
        viewBox='0 0 55 55'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <rect
          width='55'
          height='55'
          rx='27.5'
          fill='#FF9D00'
          fill-opacity='0.16'
        />
        <circle cx='27.3374' cy='27.5' r='21.1538' fill='#FF9D00' />
        <path
          d='M32.6328 19.6967C30.6969 19.6967 29.0019 20.5292 27.9453 21.9364C26.8888 20.5292 25.1937 19.6967 23.2578 19.6967C21.7168 19.6985 20.2394 20.3114 19.1497 21.4011C18.06 22.4908 17.447 23.9682 17.4453 25.5092C17.4453 32.0717 27.1756 37.3836 27.59 37.603C27.6992 37.6617 27.8213 37.6925 27.9453 37.6925C28.0693 37.6925 28.1914 37.6617 28.3006 37.603C28.715 37.3836 38.4453 32.0717 38.4453 25.5092C38.4436 23.9682 37.8306 22.4908 36.741 21.4011C35.6513 20.3114 34.1739 19.6985 32.6328 19.6967ZM27.9453 36.0842C26.2334 35.0867 18.9453 30.5427 18.9453 25.5092C18.9468 24.366 19.4016 23.2699 20.2101 22.4615C21.0185 21.6531 22.1145 21.1982 23.2578 21.1967C25.0813 21.1967 26.6122 22.168 27.2516 23.728C27.3081 23.8656 27.4042 23.9832 27.5277 24.066C27.6512 24.1488 27.7966 24.193 27.9453 24.193C28.094 24.193 28.2394 24.1488 28.3629 24.066C28.4864 23.9832 28.5826 23.8656 28.6391 23.728C29.2784 22.1652 30.8094 21.1967 32.6328 21.1967C33.7761 21.1982 34.8721 21.6531 35.6806 22.4615C36.489 23.2699 36.9438 24.366 36.9453 25.5092C36.9453 30.5352 29.6553 35.0858 27.9453 36.0842Z'
          fill='white'
        />
      </svg>
    ),
    title: "Peace of Mind",
    body: "Your calm digital companion handles rent, tenants, and compliance so you can focus on growing your rental income.",
  },
];

export default function WhatWeProvide() {
  return (
    <section className='max-w-[1265px] mx-auto px-6 md:px-10 py-16'>
      <header className='text-center mb-10'>
        <h2 className='text-3xl md:text-5xl font-extrabold tracking-tight leading-tight'>
          Why Canadian Property Owners
          <br className='hidden sm:block' /> Choose HomeOwner
        </h2>
        <p className='mt-3 text-base md:text-lg text-gray-500 max-w-[600px] mx-auto'>
          Built specifically for the Canadian market with local landlord-tenant
          laws, rent rules, and province-specific compliance built in.
        </p>
      </header>

      <div className='flex flex-col lg:flex-row items-center gap-8 lg:gap-12'>
        <div className='w-full lg:w-1/2 rounded-3xl overflow-hidden'>
          <img
            src={familyHome}
            alt='Family sitting together in their home'
            className='w-full h-full object-cover rounded-3xl'
          />
        </div>

        <div className='w-full lg:w-1/2 flex flex-col gap-5'>
          {reasons.map((r, idx) => (
            <div
              key={idx}
              className='flex flex-col gap-3 items-start bg-[#FFF8F0] rounded-2xl p-5 shadow-sm hover:shadow-md transition-shadow'>
              <div className='shrink-0 mt-0'>{r.icon}</div>
              <div>
                <h3 className='text-lg font-semibold mb-1 text-gray-900'>
                  {r.title}
                </h3>
                <p className='text-sm text-gray-600 leading-6'>{r.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
